import { Operator, type Field, type RuleType } from "react-querybuilder";

export const validator = (r: RuleType) => !!r.value;

const defaultOperators: Operator[] = [
  { name: "null", label: "is null" },
  { name: "notNull", label: "is not null" },
];

const textOperators: Operator[] = [
  { name: "contains", label: "contains" },
  { name: "beginsWith", label: "begins with" },
  { name: "endsWith", label: "ends with" },
  { name: "doesNotContain", label: "does not contain" },
  { name: "doesNotBeginWith", label: "does not begin with" },
  { name: "doesNotEndWith", label: "does not end with" },
  ...defaultOperators,
];

const numberOperators: Operator[] = [
  { name: "=", label: "equal to" },
  { name: "<", label: "less than" },
  { name: "<=", label: "less than or equal to" },
  { name: ">", label: "greater than" },
  { name: ">=", label: "greater than or equal to" },
  ...defaultOperators,
];

const selectOperators: Operator[] = [
  { name: "in", label: "in" },
  { name: "notIn", label: "not in" },
  ...defaultOperators,
];

const dateOperators: Operator[] = [
  { name: "=", label: "on" },
  { name: "!=", label: "not on" },
  { name: "<", label: "before" },
  { name: "<=", label: "on or before" },
  { name: ">", label: "after" },
  { name: ">=", label: "on or after" },
  ...defaultOperators,
];

export const fields: Field[] = [
  {
    name: "Select",
    label: "Select",
    valueEditorType: "select",
    operators: selectOperators,
    values: [
      {
        name: "Select",
        label: "Select",
      },
    ],
  },
  {
    name: "role",
    label: "Role",
    inputType: "text",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  },
  {
    name: "status",
    label: "Status",
    valueEditorType: "select",
    operators: selectOperators,
    comparator: "datatype",
    values: [
      {
        name: "Select",
        label: "Select",
      },
      {
        name: "enable",
        label: "Enable",
      },
      {
        name: "disabled",
        label: "Disabled",
      },
    ],
  },
  {
    name: "roleType",
    label: "Role Type",
    valueEditorType: "select",
    operators: selectOperators,
    comparator: "datatype",
    values: [
      {
        name: "Select",
        label: "Select",
      },
      {
        name: "admin",
        label: "Admin",
      },
      {
        name: "manager",
        label: "Manager",
      },
      {
        name: "executive",
        label: "Executive",
      },
      {
        name: "support",
        label: "Support",
      },
    ],
  },
  {
    name: "roleLevel",
    label: "Role level",
    valueEditorType: "text",
    operators: numberOperators,
    comparator: "datatype",
  },
  {
    name: "dateCreated",
    label: "Date Created",
    operators: dateOperators,
    datatype: "date",
    inputType: "date",
  },
  {
    name: "companyName",
    label: "Company Name",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  },
  {
    name: "location",
    label: "Location",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  },
  {
    name: "email",
    label: "Email",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  },
];

export const dynamicFields: Field[] = [
  {
    name: "document",
    label: "Document",
    inputType: "text",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  },
  {
    name: "filesize",
    label: "File size",
    valueEditorType: "text",
    operators: numberOperators,
    comparator: "datatype",
  },
  // {
  //   name: "dateCreated",
  //   label: "Date Created",
  //   operators: dateOperators,
  //   datatype: "date",
  //   inputType: "date",
  // },
  {
    name: "owner",
    label: "Owner",
    valueEditorType: "text",
    operators: textOperators,
    comparator: "datatype",
  }
];

